import { Icon } from '@ftr/foundation'
import { Observable } from 'rxjs'
import { ComplexFilter } from './ComplexFilter'

export class DateFilter extends ComplexFilter {
  constructor(
    filterKey: string,
    collapsible: boolean,
    icon: Icon,
    title?: string | Observable<string>,
    noClear?: boolean,
    isEnabled?: Observable<boolean>,
  ) {
    super('date', filterKey, collapsible, icon, title, undefined, noClear, [], isEnabled)
  }
}
